var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproveAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#FAFAFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5630_18679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0583 11.0002L16.4927 9.21633L16.7108 6.855L14.3944 6.32883L13.1817 4.28833L11 5.22516L8.81832 4.28833L7.60557 6.32883L5.28915 6.84858L5.50732 9.20991L3.94165 11.0002L5.50732 12.784L5.28915 15.1517L7.60557 15.6779L8.81832 17.7184L11 16.7752L13.1817 17.712L14.3944 15.6715L16.7108 15.1453L16.4927 12.784L18.0583 11.0002ZM9.71665 14.2085L7.14998 11.6418L8.05473 10.7371L9.71665 12.3926L13.9452 8.164L14.85 9.07516L9.71665 14.2085Z",
    fill: "#3A3A3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5630_18679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.4,
    height: 15.4,
    fill: "white",
    transform: "translate(3.30005 3.30005)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveAction);
export default __webpack_public_path__ + "static/media/approveAction.6b6fbe321dcdf765ca63a4fdc29654ba.svg";
export { ForwardRef as ReactComponent };